import "../../styles/upload.css";

/** A report is a set of named lists; each list's length is what matters at a
 * glance, and its rows are there to be read. A short list opens by itself; a
 * long one waits to be asked, and shows its first 200 rows. Shared by every
 * import that answers with one: the workbooks on Upload and the Red List. */
export default function ReportView({ report }: { report: Record<string, unknown> }) {
  const entries = Object.entries(report);
  const lists = entries.filter(([, value]) => Array.isArray(value)) as [string, unknown[]][];
  const facts = entries.filter(([, value]) => !Array.isArray(value) && (typeof value !== "object" || value === null));
  return (
    <div className="import-report">
      {facts.length > 0 ? (
        <dl className="import-report-facts">
          {facts.map(([key, value]) => (
            <div key={key}>
              <dt>{key.replace(/_/g, " ")}</dt>
              <dd>{String(value)}</dd>
            </div>
          ))}
        </dl>
      ) : null}
      {lists.map(([key, value]) => (
        <details key={key} className="import-report-list" open={value.length > 0 && value.length <= 12}>
          <summary>
            {key.replace(/_/g, " ")} <span className="count-badge">{value.length}</span>
          </summary>
          {value.length === 0 ? (
            <p className="import-report-none">None.</p>
          ) : (
            <ul>
              {value.slice(0, 200).map((item, index) => (
                <li key={index}>{typeof item === "object" && item !== null ? Object.values(item as object).join(" · ") : String(item)}</li>
              ))}
            </ul>
          )}
        </details>
      ))}
    </div>
  );
}
